import React from "react";
import { openCanvasPortal } from '@/utils/linksUtils';
import { RedirectIcon } from '@/components/MenusIcons/MenusIcons';
import Button from '@/components/Button/Button';
import { useSelectedStudent } from '@context/SelectedStudentContext';
import { useSchool } from '@context/SchoolContext';
import { ButtonSkeleton } from '@components/Skeletons/Skeletons';
import { useSkeletonLoader } from '@/hooks/useSkeletonLoader/useSkeletonLoader';
import { useTasklistDisplayRuntime } from '@/hooks/useTasklistDisplayRuntime/useTasklistDisplayRuntime';

export const Footer = () => {
    const { k12SchoolHref, showK12SchoolCta, isReady: k12PortalReady } = useTasklistDisplayRuntime();
    const olsNavigable = k12PortalReady && showK12SchoolCta && Boolean(k12SchoolHref);
    const handleOLSClick = () => {
        if (olsNavigable) {
            openCanvasPortal(k12SchoolHref);
        }
    };

    const { selectedStudent } = useSelectedStudent();
    const { data: schoolData, error: schoolError } = useSchool();
    const showSkeleton = useSkeletonLoader({
      schoolData,
      schoolError,
      selectedStudent,
      retryDelay: 3000,
      initialDelay: 2000,
      maxRetries: 2,
    });

    const element = (
    <>
        <div className="aside-footer container-fluid bg-color-blue-1" id="sidebarFooter">
            {showSkeleton ? (
                <ButtonSkeleton />
                ) : (    
                <div className="olsCanvasWrapper">
                    <Button
                        label={olsNavigable ? "Go to K12 School (OLS)" : "K12 School (OLS) Available soon"}
                        icon={olsNavigable ? <RedirectIcon /> : undefined}
                        iconPosition="after"
                        size="lg"
                        variant="fill"
                        width="fill"
                        color="primary"
                        breakpoint="all"
                        onClick={handleOLSClick}
                        className="ols_btn"
                        disabled={!olsNavigable}
                    />             
                </div>
            )}
            <div className="footerWrapper">
                <ul className="footerLinks">
                    <li>
                        <a target="_blank" href="https://www.k12.com/terms-of-use/">Terms</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.stridelearning.com/privacy-policy/">Privacy</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.k12.com/ip-policy/">Copyright</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.k12.com/accessibility/">Accessibility</a>
                    </li>
                </ul>
                <div className="copyright">
                    Copyright &copy; {new Date().getFullYear()} Stride, Inc. All rights reserved.
                </div>
            </div>
        </div>
    </>
    )
    return element; 
}
